import i18n from "@/i18n";
import { ChatMessage } from "@/types";
import { exportStingToTxtFile } from "@/utils/Export/export.util";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils.util";

// #region exportSingleMessageToTxtFile
export function exportSingleMessageToTxtFile(message: ChatMessage): void {
  if (!message || !message.content) {
    genericFailureToast(i18n.t("Message content is empty"));
    return;
  }

  const isExported = exportStingToTxtFile(
    message.content,
    `message-${message.id}`
  );

  if (isExported) {
    genericSuccessToast(i18n.t("Message exported successfully"));
  } else {
    genericFailureToast(i18n.t("Failed to export message"));
  }
}
// #endregion exportSingleMessageToTxtFile
